import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 15px 0;
`;
